import authService from 'api/auth'
import authHelper from 'api/auth/helper'

import * as mutationTypes from 'store/mutationTypes'
import TRACKING_EVENTS from 'constants/trackingEvents'
import analyticsLib from 'lib/analytics'
import storageLib from 'lib/storage'

export const login = function ({ commit }, result) {
  if (!result) throw new Error('result')

  return analyticsLib.trackEvent(TRACKING_EVENTS.LoggedIn, {}).then(() => {
    authHelper.setAuthToken(result.token)
    storageLib.setSessionToken()

    return commit(mutationTypes.LOGIN_SUCCESS)
  })
}

export const logout = ({ commit }) => {
  return analyticsLib.trackEvent(TRACKING_EVENTS.LoggedOut, {}).then(() => {
    authService.logout()

    commit(mutationTypes.SET_CURRENT_USER, null)

    return commit(mutationTypes.LOGOUT_SUCCESS)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js